import React from "react";
import { Link } from "react-router-dom";
import { SiteLayout } from "@/components/SiteLayout";
import { useI18n } from "@/lib/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_CONTENT } from "@/content/faqContent";

export default function Faq() {
  const { lang } = useI18n();
  const content = FAQ_CONTENT[lang];
  return (
    <SiteLayout>
      <div className="mx-auto max-w-3xl px-5 py-16">
        <h1 className="font-display text-4xl sm:text-5xl tracking-tighter" data-testid="faq-title">
          {content.title}
        </h1>
        <Accordion type="single" collapsible className="mt-8" data-testid="faq-accordion">
          {content.items.map(([question, answer], index) => (
            <AccordionItem key={question} value={`i${index}`}>
              <AccordionTrigger data-testid={`faq-q-${index}`} className="text-left">
                {question}
              </AccordionTrigger>
              <AccordionContent className="text-ink-soft">{answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-14">
          <h2 className="font-display text-2xl tracking-tight">{content.termsTitle}</h2>
          <pre data-testid="terms-text" className="mt-4 whitespace-pre-wrap font-sans text-sm text-ink-soft">
            {content.termsSummary.join("\n")}
          </pre>
          <Link to="/syarat-dan-ketentuan" data-testid="faq-terms-link" className="mt-4 inline-block text-sm text-lm-red underline">
            {content.termsLink}
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}
